export const POSTS = [
  {
    slug: "gst-registration-checklist",
    title: "GST Registration: The Complete Checklist for New Businesses",
    category: "GST",
    date: "17 Jan 2026",
    readTime: "6 min read",
    excerpt:
      "Everything you must gather, verify and file to obtain a GSTIN without notices, delays or objections.",
    body: [
      {
        h: "Do you actually need to register?",
        p: [
          "Registration becomes mandatory once your aggregate turnover crosses ₹40 lakh for goods or ₹20 lakh for services. But the threshold isn't the only trigger — anyone selling inter-state, selling through e-commerce platforms, or operating as a casual taxable person in a state where they have no fixed presence must register regardless of turnover.",
          "Registering below the threshold is often still smart: it unlocks input tax credit for your buyers and lets you serve larger clients whose finance teams insist on a GSTIN on every invoice.",
        ],
      },
      {
        h: "The document checklist",
        p: [
          "Keep these ready before you start the application: PAN and Aadhaar of the proprietor or directors; the business PAN and incorporation certificate; address proof of the principal place of business; a bank statement or cancelled cheque; and a digital signature certificate for companies and LLPs.",
          "Most objections from the department come from two things — a blurry or outdated address proof, and a mismatch between the name on PAN and the name on the application. Fix both before filing, not after a notice arrives.",
        ],
      },
      {
        h: "The process, step by step",
        p: [
          "The application itself is straightforward: generate a TRN on the GST portal, file Form REG-01 with your documents, respond to any queries the officer raises, and receive your GSTIN — typically within 3 to 7 business days when the paperwork is clean.",
          "After registration, the real discipline begins. Set up a return calendar for GSTR-1 and GSTR-3B, watch your e-invoicing obligations as you scale, and reconcile input tax credit monthly so your working capital doesn't quietly leak.",
        ],
      },
      {
        h: "Where professionals earn their fee",
        p: [
          "Choosing the right category, drafting a clean declaration, handling portal queries and setting up reconciliations are where a chartered accountant pays for themselves. If you'd rather hand the entire lifecycle to a team that files these every day, that is literally our day job — book a free consultation and we'll map it out.",
        ],
      },
    ],
  },
  {
    slug: "old-vs-new-tax-regime",
    title: "Old vs New Tax Regime: Picking Right for FY 2025-26",
    category: "Income Tax",
    date: "13 Jan 2026",
    readTime: "5 min read",
    excerpt:
      "A plain-English way to decide between the two regimes — before you file, not after.",
    body: [
      {
        h: "The default changed — and that matters",
        p: [
          "The new regime is now the default for every taxpayer who doesn't actively choose otherwise. It comes with revised slab rates and a rebate that keeps income up to ₹12 lakh effectively tax-free in FY 2025-26 — but it asks you to give up most deductions.",
          "The old regime keeps the familiar deduction toolkit: Section 80C investments, HRA, home-loan interest and the rest, at the older slab rates.",
        ],
      },
      {
        h: "The rule of thumb",
        p: [
          "If your income is straightforward — salary, some interest, little else — the new regime usually wins, and the rebate makes it a runaway for incomes under the rebate ceiling.",
          "The old regime only fights back when your deductions are heavy: a large home-loan interest bill, full 80C usage, HRA in a metro, or family health premiums under Section 80D. The more of those you stack, the more the old regime claws back.",
        ],
      },
      {
        h: "Don't guess — compute",
        p: [
          "The honest answer is that no rule of thumb survives contact with a real salary structure. Business owners and freelancers have it harder still, because business income interacts with presumptive taxation and advance-tax planning in ways the regimes treat differently.",
          "Before you file, get both computations done side by side — it takes a professional minutes and can change the answer entirely. Our income tax service does exactly this as standard: regime comparison, filing, and a planning note for the year ahead. Talk to us before the deadline crowd does.",
        ],
      },
    ],
  },
  {
    slug: "dpiit-recognition-benefits",
    title: "DPIIT Recognition: The Startup Benefits Most Founders Miss",
    category: "Startups",
    date: "9 Jan 2026",
    readTime: "4 min read",
    excerpt:
      "Beyond the tax holiday — what Startup India recognition actually unlocks, and who qualifies.",
    body: [
      {
        h: "Who qualifies in the first place",
        p: [
          "The bar is simpler than most founders assume: a private limited company, LLP or registered partnership that is less than ten years old, with turnover under ₹100 crore in any year, and a product or process that shows innovation, improvement or scalability with employment potential.",
          "Government fees are nil — recognition costs you nothing but preparation.",
        ],
      },
      {
        h: "What recognition unlocks",
        p: [
          "The headline benefit is the three-year income-tax holiday under Section 80-IAC, which can defer your tax bill precisely during the years cash matters most. Recognition also supports angel tax exemption, faster processing and rebates on intellectual property filings, and access to the Startup India Seed Fund.",
          "The quieter benefits matter too: self-certification across nine labour laws cuts your compliance surface at the exact stage when every hour of founder time is scarce.",
        ],
      },
      {
        h: "Where applications go wrong",
        p: [
          "Most rejections trace back to a thin write-up — applications that describe a business but never articulate what is new about it. The second failure point is incomplete documentation: incorporation certificate, PAN, a working website or pitch link, and founder details, all consistent with each other.",
          "We prepare the eligibility review, the application and the query responses end to end — and for funded-stage startups, pair it with pitch decks and financial models that make the recognition count for something. Get in touch if you'd like yours reviewed before filing.",
        ],
      },
    ],
  },
];

export const getPost = (slug) => POSTS.find((p) => p.slug === slug);
